type AxiosErrorMessage = {
  response?: {
    data?: {
      message?: string
    }
  }
}

function isAxiosError(
  error: unknown,
): error is { isAxiosError: true } & AxiosErrorMessage {
  return (
    error != null &&
    typeof error === 'object' &&
    'isAxiosError' in error &&
    (error as { isAxiosError: unknown }).isAxiosError === true
  )
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    return error.response?.data?.message ?? fallback
  }
  if (
    error != null &&
    typeof error === 'object' &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message
  }
  return fallback
}
